import { onUnmounted } from 'vue';
import { useSocketStore } from '../stores/socketStore';

// Socket listeners scoped to the component that registers them. The socket
// lives in the store for the whole page, but the chat components mount and
// unmount with every LiveKit session, so handlers registered straight on the
// socket piled up: one full set per remount, each still firing (XN-4539).
export default function useSocketListeners() {
  const socketStore = useSocketStore();
  const bound = [];
  let unmounted = false;

  onUnmounted(() => {
    unmounted = true;
    bound.splice(0).forEach(([eventName, handler]) => socketStore.off(eventName, handler));
  });

  return {
    on(eventName, handler) {
      // A registration can arrive after unmount: GroupsComponent awaits
      // nextTick() in onMounted before registering. Nothing would ever
      // remove that listener, so drop it.
      if (unmounted) return;
      socketStore.on(eventName, handler);
      bound.push([eventName, handler]);
    },
  };
}
